import initEETrialBanner from 'ee/ee_trial_banner';
import { initSamlReloadModal } from './saml_sso/index.js?vue3';

// EE specific calls
initEETrialBanner();

initSamlReloadModal();
